import React from 'react';
import { Box, Button, Paper, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';

const EmptyState = ({ title, description, actionLabel, actionTo }) => (
  <Paper elevation={0} style={{ padding: '2rem', textAlign: 'center' }}>
    <Typography variant="h6">{title}</Typography>
    <Typography color="textSecondary" style={{ margin: '0.5rem 0 1rem' }}>
      {description}
    </Typography>
    {actionLabel && actionTo && (
      <Box>
        <Button variant="contained" color="primary" component={Link} to={actionTo}>
          {actionLabel}
        </Button>
      </Box>
    )}
  </Paper>
);

export default EmptyState;
